import { DateRange, RangeType } from "rsuite/DateRangePicker";
import moment from "moment";

export const predefinedRanges: RangeType<DateRange>[] = [
  {
    label: "Aujourd'hui",
    value: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
    placement: "bottom",
  },
  {
    label: "Hier",
    value: [
      moment().subtract(1, "days").startOf("day").toDate(),
      moment().subtract(1, "days").endOf("day").toDate(),
    ],
    placement: "bottom",
  },
  {
    label: "Les 7 derniers jours",
    value: [moment().subtract(7, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    placement: "bottom",
  },
  {
    label: "Les 30 derniers jours",
    value: [moment().subtract(30, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    placement: "bottom",
  },
];
